import { Portlet } from '../../../_services/PortletService';
import { Workspace, WorkspaceConfig } from './types';

const CATEGORY_ICONS: Record<string, string> = {
  'Dashboards': '📊',
  'Academic': '🎓',
  'Operations': '💼',
  'AI Tools': '🤖',
};

const CATEGORY_ORDER = ['Dashboards', 'Academic', 'Operations', 'AI Tools'];

/**
 * Build default workspace configuration from a list of portlets.
 * Groups portlets by their explicit `category` field.
 * Portlets without a category only appear in "All Apps".
 */
export function buildDefaultWorkspaces(portlets: Portlet[]): WorkspaceConfig {
  const groups = new Map<string, string[]>();

  portlets.forEach((portlet) => {
    if (!portlet.category) return;
    if (!groups.has(portlet.category)) {
      groups.set(portlet.category, []);
    }
    groups.get(portlet.category)!.push(portlet.id);
  });

  const workspaces: Workspace[] = [
    {
      id: 'ws-all-apps',
      name: 'All Apps',
      icon: '🏠',
      portletIds: [],
      isDefault: true,
      isAllApps: true,
      order: 0,
    },
  ];

  let order = 1;

  CATEGORY_ORDER.forEach((categoryName) => {
    const portletIds = groups.get(categoryName) || [];
    if (portletIds.length > 0) {
      workspaces.push({
        id: `ws-${categoryName.toLowerCase().replace(/\s+/g, '-')}`,
        name: categoryName,
        icon: CATEGORY_ICONS[categoryName] || '📁',
        portletIds,
        isDefault: true,
        isAllApps: false,
        order: order++,
      });
    }
  });

  // Include any categories not in the predefined order
  groups.forEach((portletIds, categoryName) => {
    if (!CATEGORY_ORDER.includes(categoryName) && portletIds.length > 0) {
      workspaces.push({
        id: `ws-${categoryName.toLowerCase().replace(/\s+/g, '-')}`,
        name: categoryName,
        icon: CATEGORY_ICONS[categoryName] || '📁',
        portletIds,
        isDefault: true,
        isAllApps: false,
        order: order++,
      });
    }
  });

  return {
    workspaces,
    activeWorkspaceId: 'ws-all-apps',
    version: 1,
  };
}
